/* ---------------------------------------------------------------------------
   A11Y — WCAG 2.2.2 (Pause, Stop, Hide)
   La slideshow ruota da sola ogni N secondi in loop e il tema non offre alcun
   modo di fermarla (il pause-on-hover appartiene a un altro componente, e lo
   stop su shopify:block:select vale solo dentro l'editor tema).

   SlideshowCarousel espone "get player()", quindi possiamo pilotare il Player
   dall'esterno senza modificare theme.js (che e' minificato).

   Nota: il tema sincronizza l'anello di avanzamento solo su player:start/stop e
   sugli eventi di visibilita', NON su player:pause -> la variabile CSS
   --slideshow-progress-play-state la aggiorniamo noi quando mettiamo in pausa.
   --------------------------------------------------------------------------- */
(() => {
  const setup = async (button) => {
    const carousel = document.getElementById(button.getAttribute('aria-controls'));
    if (!carousel) return;

    await customElements.whenDefined('slideshow-carousel');
    // il Player viene creato in connectedCallback: se manca, l'autoplay non e'
    // attivo e un bottone di pausa sarebbe un controllo finto -> lo lasciamo nascosto.
    const player = carousel.player;
    if (!player) return;

    const label = button.querySelector('[data-autoplay-label]');
    const iconPause = button.querySelector('[data-icon-pause]');
    const iconPlay = button.querySelector('[data-icon-play]');
    let paused = null;

    const render = (isPaused) => {
      if (paused === isPaused) return;
      paused = isPaused;
      const text = button.getAttribute(isPaused ? 'data-label-resume' : 'data-label-pause');
      if (label) label.textContent = text;
      button.setAttribute('title', text);
      if (iconPause) iconPause.style.display = isPaused ? 'none' : '';
      if (iconPlay) iconPlay.style.display = isPaused ? '' : 'none';
    };

    const pause = () => {
      player.pause();
      // il tema non gestisce player:pause: fermiamo noi l'anello di avanzamento
      carousel.style.setProperty('--slideshow-progress-play-state', 'paused');
      render(true);
    };
    const resume = () => {
      // resume(true) riavvia il timer -> emette player:start -> il tema
      // ripristina da solo durata e stato dell'anello.
      player.resume(true);
      render(false);
    };

    button.addEventListener('click', () => (paused ? resume() : pause()));

    // Chi arriva col Tab dentro la slideshow sta leggendo: non spostiamogli
    // il contenuto sotto gli occhi. Nessuna ripresa automatica: il controllo
    // resta all'utente, e il bottone riflette sempre lo stato reale.
    carousel.addEventListener('focusin', () => { if (!paused) pause(); });

    // Chi ha chiesto meno animazioni parte con la rotazione gia' ferma.
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce.matches) pause(); else render(false);

    button.hidden = false;
  };

  const init = () => document.querySelectorAll('[data-slideshow-autoplay-toggle]').forEach(setup);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
